export default __webpack_public_path__ + "static/media/okay.af857933.svg";